module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Demi.54242bf1.ttf";